import React from 'react';
import { FileText, Globe, Video, Clock, Search, Zap } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    name: 'Video Transcription',
    description: 'Automatically convert speech to text with high accuracy across multiple accents and languages.',
    icon: Video
  }, {
    name: 'Blog Post Generation',
    description: 'Transform video transcripts into well-structured, SEO-friendly blog posts with proper formatting.',
    icon: FileText
  }, {
    name: 'Language Dubbing',
    description: 'Dub your videos into multiple languages with natural-sounding voices that maintain tone and inflection.',
    icon: Globe
  }, {
    name: 'Time Saving',
    description: 'Reduce content creation time by up to 90% with our automated transcription and conversion tools.',
    icon: Clock
  }, {
    name: 'SEO Optimization',
    description: 'Automatically optimize your blog posts for search engines with keyword analysis and metadata.',
    icon: Search
  }, {
    name: 'Fast Processing',
    description: 'Get your transcriptions and blog posts in minutes, not hours or days.',
    icon: Zap
  }];
  return <div id="features" className="py-12 bg-white" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="lg:text-center" data-id="element-22">
          <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase" data-id="element-23">
            Features
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-id="element-24">
            Everything you need for content repurposing
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto" data-id="element-25">
            Turn your video content into multiple formats to reach a wider
            audience and maximize your content ROI.
          </p>
        </div>
        <div className="mt-10" data-id="element-26">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10" data-id="element-27">
            {features.map(feature => <div key={feature.name} className="relative" data-id="element-28">
                <dt data-id="element-29">
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white" data-id="element-30">
                    <feature.icon className="h-6 w-6" aria-hidden="true" data-id="element-31" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900" data-id="element-32">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500" data-id="element-33">
                  {feature.description}
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </div>;
}